import { Injectable } from '@angular/core';
import { SyncLog } from '../../entities/sync-log';
import { LocalDbService } from '../local-db-service';

@Injectable({ providedIn: 'root' })
export class SyncLogRepository {
  private get table() {
    return this.db.syncLogsTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async create(data: Partial<SyncLog>): Promise<number> {
    return this.table.add(new SyncLog(data));
  }

  async getAll(): Promise<SyncLog[]> {
    const rows = await this.table.toArray();
    return rows.map(row => new SyncLog(row));
  }
}
